export default __webpack_public_path__ + "static/texture-over-dark-e699d44614a0bf1ef2d4fb7e5b8e33e9.png";